import { withRouter } from 'next/router';
import React from 'react';
import dynamic from 'next/dynamic'
import SeminarPage from '../components/static/seminarPage';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import { getSeminars } from "../api/seminars";


const Seminar = (props) => {
    const meta = {
		title: "Seminar | Bayan",
		description: "This seminar program is separate from Bayan’s graduate degree programs, and participation does not require admission to Bayan Islamic Graduate School. No academic credit or transcript is provided. This program provides enrichment and inspiration for serious students of knowledge.",
		route: "seminar",
	}
    return ( 
        <Layout theme={props.theme} meta={meta}>
            <SeminarPage seminarData={props?.seminarData} />
        </Layout>
     );
}
export async function getServerSideProps(ctx) {
    const seminarData = await getSeminars();
    return { props: { seminarData: seminarData } }
}
export default withRouter(Seminar);
